import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  currentPriceText: {
    id: 'pd.discount.pricesInfo.currentPrice.text',
    defaultMessage: 'Aktuální cena',
  },
  recentMinPriceText: {
    id: 'pd.discount.pricesInfo.recentMinPrice.text',
    defaultMessage: 'Poslední nejnižší cena',
  },
  modalTitle: {
    id: 'pd.discount.pricesInfo.modal.title',
    defaultMessage: 'Přehled cen',
  },
  modalPriceAfterDiscountText: {
    id: 'pd.discount.pricesInfo.modal.priceAfterDiscount.text',
    defaultMessage: 'Cena položky po uplatnění slevového kódu',
  },
  modalCurrentPriceText: {
    id: 'pd.discount.pricesInfo.modal.currentPrice.text',
    defaultMessage: 'Aktuální cena položky',
  },
  modalRecentMinPriceText: {
    id: 'pd.discount.pricesInfo.modal.recentMinPrice.text',
    defaultMessage:
      'Nejnižší cena, za kterou se produkt nabízel v posledních 30 dnech před zahájením akce/výprodeje',
  },
  modalAnchorPriceText: {
    id: 'pd.discount.pricesInfo.modal.anchorPrice.text',
    defaultMessage: 'Cena, za kterou jsme tento produkt prodávali k {date}',
  },
  modalMoreInfoLinkText: {
    id: 'pd.discount.pricesInfo.modal.moreInfoLink.text',
    defaultMessage: 'Více o zobrazení cen',
  },
  modalMoreInfoLinkUrl: {
    id: 'pd.discount.pricesInfo.modal.moreInfoLink.url',
    defaultMessage:
      'https://www.notino.cz/cs/zobrazeni-cen-v-detailu-produktu-a-slevovych-kodu-157150.html',
  },
  modalOkButtonText: {
    id: 'pd.discount.pricesInfo.modal.okButton.text',
    defaultMessage: 'Rozumím',
  },
});
